export default function Background() {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 0,
      overflow: 'hidden', pointerEvents: 'none',
      background: '#06080f',
    }}>
      <div style={{
        position: 'absolute', top: '-10%', left: '-5%',
        width: 700, height: 700, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(59,130,246,0.14) 0%, transparent 70%)',
        animation: 'float-slow 12s ease-in-out infinite',
      }} />
      <div style={{
        position: 'absolute', top: '30%', right: '-10%',
        width: 600, height: 600, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)',
        animation: 'float-medium 15s ease-in-out infinite',
      }} />
      <div style={{
        position: 'absolute', bottom: '5%', left: '25%',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(34,211,238,0.07) 0%, transparent 70%)',
        animation: 'float-slow 18s ease-in-out infinite reverse',
      }} />
      <div style={{
        position: 'absolute', top: '60%', left: '5%',
        width: 350, height: 350, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
        animation: 'float-medium 10s ease-in-out infinite',
      }} />
    </div>
  );
}
